import KeyTakeawayNumber from './KeyTakeawayNumber';
export default KeyTakeawayNumber;
